import EventLinksCellRenderer from '../../components/EventLinksCellRender';

const FETCH_NOTIFICATIONS_SUCCESS = 'FETCH_NOTIFICATIONS_SUCCESS';
const DELETE_NOTIFICATIONS_SUCCESS = 'DELETE_NOTIFICATIONS_SUCCESS';
const NOTIFICATION_SELECTED_ROWS = 'NOTIFICATION_SELECTED_ROWS';
const UPDATE_EVENT_NAME = 'UPDATE_EVENT_NAME';
const FILTER_PRESETS = 'FILTER_PRESETS';
const UPDATE_SELECTED_PRESETS = 'UPDATE_SELECTED_PRESETS';

const initialState = {
  notifications: {
    notifications: [],
    notificationsCount: 0,
  },
  filters: [],
  selectedFilters: [],
  eventName: '',
  deleteNotificationsSuccess: false,
  columnDefs: [
    {
      headerName: 'Event Name',
      field: 'event_name',
      pinned: 'left',
      filter: 'agTextColumnFilter',
      checkboxSelection: true,
      headerCheckboxSelection: true,
    },
    { headerName: 'Venue', field: 'venue_name', filter: 'agTextColumnFilter' },
    { headerName: 'Date of Event', field: 'event_date', filter: 'agDateColumnFilter' },
    { headerName: 'Preset Filter', field: 'filter_name', filter: 'agTextColumnFilter' },
    {
      headerName: 'Datetime of Notification',
      field: 'datetime',
      filter: 'agDateColumnFilter',
    },
    {
      headerName: 'Event Links',
      field: 'event_links',
      filter: 'agTextColumnFilter',
      cellRendererFramework: EventLinksCellRenderer,
    },
  ],
  // TODO: Use this...
  defaultColDefs: {
    sortable: true,
    filter: true,
    resizable: true,
  },
};

const notifications = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_NOTIFICATIONS_SUCCESS:
      return { ...state, notifications: action.notifications };
    case UPDATE_EVENT_NAME:
      return { ...state, eventName: action.eventName };
    case DELETE_NOTIFICATIONS_SUCCESS:
      return { ...state, deleteNotificationsSuccess: action.deleteNotificationsSuccess };
    case NOTIFICATION_SELECTED_ROWS:
      return { ...state, selectedNotificationRows: action.selectedNotificationRows };
    case FILTER_PRESETS:
      return { ...state, filters: action.filters };
    case UPDATE_SELECTED_PRESETS:
      return { ...state, selectedFilters: action.selectedFilters };
    default:
      return state;
  }
};

export default notifications;
